export const ButtonStyleEnum = Object.freeze({
  Primary: 'Primary',
  Secondary: 'Secondary',
  Tertiary: 'Tertiary',
  Text: 'Text & Icon',
});

export const ButtonIconEnum = Object.freeze({
  Skewer: 'Skewer',
  Knife: 'Knife',
});
